import { DataSource, Layout, LayoutHeader, Table } from "@mcleod/components";

export abstract class AutogenLayoutCarrierQualificationsList extends Layout {
    layoutheaderCarrierQualList: LayoutHeader;
    sourceBrkQualProfile: DataSource;
    tableSearch: Table;
}
